import Vue from 'vue';
import VuePageTitle from 'vue-page-title';
import VueMq from 'vue-mq';
import Snotify, {SnotifyPosition} from 'vue-snotify';
import vueSmoothScroll from 'vue2-smooth-scroll';
import {Tabs, Tab} from 'vue-tabs-component';
import VueConfirmDialog from 'vue-confirm-dialog';

import App from './App.vue';
import router from './router';
import store from './store';
import firebase from 'firebase/app';
import './firebaseInit';
import Gravatar from 'vue-gravatar';
import {PAGE_TITLE_APP_NAME, PAGE_TITLE_DELIMITER, VUE_APP_MODE_PRODUCTION} from './constants/globalConstants';
import './helpers/focusRing';
import './helpers/checkLocalStorage';

import '@/scss/styles.scss';

Vue.config.productionTip = false;

if (process.env.NODE_ENV === VUE_APP_MODE_PRODUCTION) {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

Vue.component('v-gravatar', Gravatar);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);

Vue.use(VueConfirmDialog);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);

Vue.use(VuePageTitle, {
  prefix: ``,
  suffix: `${PAGE_TITLE_DELIMITER}${PAGE_TITLE_APP_NAME}`,
});

Vue.use(VueMq, {
  breakpoints: {
    'mq-xsm': 400,
    'mq-xsm-sm': 500,
    'mq-sm': 600,
    'mq-sm-md': 700,
    'mq-ipad': 769,
    'mq-md': 800,
    'mq-md-lg': 1000,
    'mq-lg': 1200,
    'mq-lg-xlg': 1400,
    'mq-xlg': 1600,
    'mq-xxlg': Infinity,
  },
});

Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.centerBottom,
  },
});

Vue.use(vueSmoothScroll);

let app;
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
      beforeCreate() {
        Vue.$snotify = this.$snotify;
      },
    }).$mount('#app');
  }
});

global.vm = app;

// -------------------------------------
// Register the Service Worker for PWA
// -------------------------------------
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(reg => {
      console.log('Service Worker registered:', reg);
    })
    .catch(err => {
      console.log('Service Worker not registered:', err);
    });
}
